/* =============================================================
   LondonMoon — theme.js
   Vanilla JS · no dependencies · ES module-ready
   ============================================================= */
(function() {
  'use strict';

  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const $  = (sel, ctx = document) => ctx.querySelector(sel);

  const Theme = window.theme || {};
  window.theme = Theme;

  Theme.formatMoney = function(cents) {
    const currency = (Theme.shop && Theme.shop.currency) || 'GBP';
    const symbol = currency === 'GBP' ? '£' : currency === 'EUR' ? '€' : currency === 'USD' ? '$' : '';
    const amount = (cents / 100).toFixed(2);
    return symbol + amount;
  };

  /* ----------- Drawer (cart + nav) ----------- */
  const Drawer = {
    open(drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-drawer-open');
      const panel = $('.drawer__panel', drawer);
      if (panel) {
        const focusable = panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        focusable && setTimeout(() => focusable.focus(), 80);
      }
    },
    close(drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-drawer-open');
    },
    bind() {
      $$('[data-drawer-open]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-drawer-open');
          const drawer = document.getElementById(id);
          drawer && Drawer.open(drawer);
        });
      });
      $$('.drawer').forEach(drawer => {
        $('.drawer__overlay', drawer)?.addEventListener('click', () => Drawer.close(drawer));
        $$('[data-drawer-close]', drawer).forEach(b => b.addEventListener('click', () => Drawer.close(drawer)));
      });
      document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        $$('.drawer[aria-hidden="false"]').forEach(d => Drawer.close(d));
      });
    },
  };

  /* ----------- Cart (Shopify AJAX API) ----------- */
  const Cart = {
    async get() {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return r.json();
    },
    async add(items) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: Array.isArray(items) ? items : [items] }),
      });
      if (!r.ok) throw await r.json();
      return r.json();
    },
    async update(id, quantity) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity }),
      });
      return r.json();
    },
    async refreshDrawer() {
      try {
        const r = await fetch(`${window.location.origin}/?section_id=cart-drawer`);
        if (!r.ok) return;
        const html = await r.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const next = tmp.querySelector('[data-cart-drawer-inner]');
        const current = $('[data-cart-drawer-inner]');
        if (next && current) current.innerHTML = next.innerHTML;
        Cart.bindLines();
      } catch (e) { console.error(e); }
    },
    updateBadge(count) {
      $$('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.toggleAttribute('hidden', count === 0);
      });
    },
    bindLines() {
      $$('[data-cart-line]').forEach(line => {
        const id = line.dataset.cartLine;
        $('[data-cart-qty-up]', line)?.addEventListener('click', async () => {
          const qty = parseInt(line.dataset.cartLineQty, 10) + 1;
          await Cart.update(id, qty);
          Cart.refresh();
        });
        $('[data-cart-qty-down]', line)?.addEventListener('click', async () => {
          const qty = Math.max(0, parseInt(line.dataset.cartLineQty, 10) - 1);
          await Cart.update(id, qty);
          Cart.refresh();
        });
        $('[data-cart-remove]', line)?.addEventListener('click', async (e) => {
          e.preventDefault();
          await Cart.update(id, 0);
          Cart.refresh();
        });
      });
    },
    async refresh() {
      const cart = await Cart.get();
      Cart.updateBadge(cart.item_count);
      await Cart.refreshDrawer();
    },
    bind() {
      Cart.bindLines();
      $$('form[action$="/cart/add"]').forEach(form => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('[type="submit"]');
          const orig = btn ? btn.innerHTML : '';
          if (btn) { btn.innerHTML = '<span class="spinner"></span>'; btn.disabled = true; }
          try {
            const fd = new FormData(form);
            const items = [{
              id: parseInt(fd.get('id'), 10),
              quantity: parseInt(fd.get('quantity') || 1, 10),
            }];
            await Cart.add(items);
            await Cart.refresh();
            const drawer = document.getElementById('cart-drawer');
            drawer && Drawer.open(drawer);
          } catch (err) {
            console.error(err);
            alert((err && err.description) || 'Could not add to cart.');
          } finally {
            if (btn) { btn.innerHTML = orig; btn.disabled = false; }
          }
        });
      });
    },
  };

  /* ----------- Variant selector ----------- */
  const Variants = {
    bind() {
      $$('[data-product-form]').forEach(form => {
        const data = JSON.parse(form.dataset.productVariants || '[]');
        const optionInputs = $$('[data-product-option]', form);
        const idInput = $('input[name="id"]', form);
        const priceEl = document.querySelector('[data-product-price]');
        const ctaEl = $('[data-add-to-cart]', form);

        function selected() {
          const opts = {};
          optionInputs.forEach(i => {
            if (i.checked || i.tagName === 'SELECT' || i.dataset.optionSelected === 'true') {
              opts[i.dataset.productOption] = i.value;
            }
          });
          return data.find(v => v.options.every((o, idx) => {
            return opts[`option${idx + 1}`] === o;
          }));
        }

        function update() {
          const v = selected();
          if (!v) return;
          if (idInput) idInput.value = v.id;
          var _main = document.querySelector('[data-pdp-main]');
          if (_main && v.featured_image && v.featured_image.src) { _main.src = v.featured_image.src; _main.removeAttribute('srcset'); }
          if (priceEl) { const pcur = priceEl.querySelector('.price__current') || priceEl; pcur.textContent = Theme.formatMoney(v.price); }
          if (ctaEl) {
            ctaEl.disabled = !v.available;
            ctaEl.textContent = v.available ? (Theme.t('add_to_bag') || 'Add to bag') : (Theme.t('sold_out') || 'Sold out');
          }
          // Update label values
          optionInputs.forEach(i => {
            const labelEl = form.querySelector(`[data-option-value-for="${i.dataset.productOption}"]`);
            if (labelEl && (i.checked || i.dataset.optionSelected === 'true')) {
              labelEl.textContent = i.value;
            }
          });
        }

        optionInputs.forEach(input => {
          input.addEventListener('change', update);
          input.addEventListener('click', e => {
            // Pills (button) — emulate radio
            if (input.tagName === 'BUTTON') {
              const same = form.querySelectorAll(`[data-product-option="${input.dataset.productOption}"]`);
              same.forEach(s => s.setAttribute('aria-checked', 'false'));
              input.setAttribute('aria-checked', 'true');
              input.dataset.optionSelected = 'true';
              same.forEach(s => { if (s !== input) s.dataset.optionSelected = 'false'; });
              update();
            }
          });
        });

        update();
      });
    },
  };

  /* ----------- Quantity stepper ----------- */
  const Qty = {
    bind() {
      $$('[data-qty-stepper]').forEach(wrap => {
        const input = $('input', wrap);
        $('[data-qty-up]', wrap)?.addEventListener('click', () => {
          input.value = Math.max(1, parseInt(input.value || 1, 10) + 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        $('[data-qty-down]', wrap)?.addEventListener('click', () => {
          input.value = Math.max(1, parseInt(input.value || 1, 10) - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    },
  };

  /* ----------- Sticky header shadow on scroll ----------- */
  const Header = {
    bind() {
      const header = $('.header');
      if (!header) return;
      const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    },
  };

  /* ----------- Lazy fade-in (intersection observer) ----------- */
  const Reveal = {
    bind() {
      const els = $$('[data-reveal]');
      if (!('IntersectionObserver' in window) || els.length === 0) {
        els.forEach(el => el.classList.add('is-revealed'));
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-revealed');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      els.forEach(el => io.observe(el));
    },
  };

  /* ----------- Boot ----------- */
  document.addEventListener('DOMContentLoaded', () => {
    Drawer.bind();
    Cart.bind();
    Variants.bind();
    Qty.bind();
    Header.bind();
    Reveal.bind();
  });

  // Expose for sections
  Theme.Drawer = Drawer;
  Theme.Cart = Cart;
  Theme.Variants = Variants;
  Theme.t = function(key) { return (Theme.strings && Theme.strings[key]) || ''; };
})();
